<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            :isShowEditButton="false"
            @removeService="removeService"
        >
            <template #content>
                <ChangeBeforeAfter>
                    <template #before>
                        <span>{{ data?.before.autoPremLoan === 'Y' ? '同意' : '不同意' }}</span>
                    </template>
                    <template #after>
                        <span>{{ data?.after.autoPremLoan ==='Y' ? '同意' : '不同意' }}</span>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';

export default {
    name: 'C4Data',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('C4');
        const removeService = () => {
            emit('removeService', code.value);
        };
        // const getAgreeText = (isAgree) => {
        //     return isAgree === true ? '同意' : '不同意';
        // }
        return { code, data, removeService };
    },
};
</script>
